import React from 'react'
import { prop } from '@neo/ramda-extra'
import ParentSize from '@visx/responsive/lib/components/ParentSize'
import { MapChartBase } from './MapChartBase'
import { styled, s } from '@vega/styled/v2'

const Container = styled.div(s(''), prop('containerStyle'))

const MapChart = ({ data, containerStyle, ...otherProps }) => {
  return (
    <Container containerStyle={containerStyle}>
      <ParentSize>
        {({ width: parentWidth, height: parentHeight }) => (
          <MapChartBase
            data={data}
            width={parentWidth}
            height={parentHeight}
            {...otherProps}
          />
        )}
      </ParentSize>
    </Container>
  )
}

export { MapChart }
